import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class DentalConsultationPageFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default DentalConsultationPageFormPresenter;
